import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "delivery-new" }
const _hoisted_2 = { class: "mr-3" }
const _hoisted_3 = { class: "text-grey" }

import {computed, nextTick, ref, watch} from 'vue';
import Error from '@/components/Error.vue';
import Loading from '@/components/Loading.vue';
import Picklist, {ApiPicklistState, ApiPicklistType} from '@/model/Picklist';
import {ProviderStatus} from '@/model/Provider';
import Provider from '@/model/Provider';
import Order, {DetailOrderFilters} from '@/model/Order';
import router from '@/router';
import DatePicker from '@/components/DatePicker.vue';
import moment from 'moment';
import {doAlert} from '@/util';
import {getProviders} from '@/api/module/provider';
import {ValueType} from '@/api/meta/filters';
import {useStorage} from '@/composables/storage';
import useDetailPicklistStore from '@/store/detailPicklist';
import {VNodeRef} from 'vue';
import useDetailOrderStore from '@/store/detailCrmOrder';

export default /*#__PURE__*/_defineComponent({
  __name: 'OrderDelivery',
  setup(__props, { expose: __expose }) {

const store = useDetailOrderStore();
const detailPicklist = useDetailPicklistStore();
useStorage(store,
    () => null,
    (route): DetailOrderFilters => {
      return {Nummer: parseInt(Array.isArray(route.params.id) ? route.params.id[0] : route.params.id)};
      // return {Nummer: parseInt(Array.isArray(route.params.id) ? route.params.id[0] : route.params.id)};
    },
);

const lieferant = ref<{value: string; text: string, name: string} | null>(null);
const BestellNr = ref('');
const Lieferdatum = ref(moment().format('YYYY-MM-DD'));
const LieferscheinNr = ref('');
const formValid = ref(false);
const lieferantenLoaded = ref(false);
const lieferanten = ref<Provider[]>([]);
const debounceLieferantenTimeout = ref<number | null>(null);
const lieferantSword = ref('');
const lieferantenLoading = ref(false);
const form = ref<HTMLFormElement & VNodeRef | undefined>();

const lieferantItems = computed(() => {
  const lieferantenOptions = lieferanten.value.map((l) => ({value: String(l.KundenNr), text: `${l.Kundname} [${l.KundenNr}]`, name: l.Kundname}));

  if (lieferant.value) {
    lieferantenOptions.unshift(lieferant.value);
  }

  const data = store.data;


  return data ?
    [
      {value: String(data?.Lieferant.LieferantNr), text: `${data?.Lieferant.LieferantName} [${data?.Lieferant.LieferantNr}]`, name: data?.Lieferant.LieferantName},
      ...lieferantenOptions,
    ] :
    lieferantenOptions;
});
const bestellItems = computed(() => {
  const order = store.data;
  return order ? [{value: order?.Nummer, text: order?.Nummer}] : [];
});
const order = computed(() => {
  return store.data;
});

function ruleRequired(val: string|null|undefined): string|true {
  if (!val) return 'erforderlich';

  return true;
}
function ruleNumber(val: string|null|undefined): string|true {
  if (!val) return true;
  if (parseInt(val).toString() !== val) return 'bitte eine ganze Zahl eingeben';

  return true;
}
async function loadLieferanten() {
  if (!lieferantSword.value) {
    return;
  }
  lieferantenLoading.value = true;
  try {
    [lieferanten.value] = await getProviders({
      KundStatus$In: [ProviderStatus.Lieferanten],
      LieferantErledigt: false,
      Fulltext$Fulltext: {
        words: [String(lieferantSword.value)],
        fields: [
          {path: ['KundenNr'], valueType: ValueType.Naked},
          {path: ['Kundname'], valueType: ValueType.StringContains},
        ],
      },
    }, []);
  } finally {
    lieferantenLoading.value = false;
  }
}

async function save() {
  try {
    const order = store.data as Order | null;
    form.value?.validate();
    if (!formValid.value) throw new Error('Bitte alle Felder korrekt ausfüllen');
    const picklist = Picklist.fromApi({
      Art: ApiPicklistType.Incoming,
      Picklistnr: LieferscheinNr.value,
      BestellNr: BestellNr.value ? parseInt(BestellNr.value) : null,
      LieferantenNr: lieferant.value !== null ? Number(lieferant.value.value) : null,
      Erstelltam: moment().format('YYYY-MM-DD'),
      Erstelltdurch: '',
      Status: ApiPicklistState.Todo,
      Kmsdatum: order?.Datum ?? '',
      Kmsuhrzeit: order?.Uhrzeit ?? '',
      Kmsprioritaet: '',
      Kmsam: Lieferdatum.value,
      Kmsdurch: '',
      Kmsbediener: null,
      Tour: [],
      Auftraege: [],
      InterneAuftraege: order?.convertedPositions ?? [],
    });

    picklist.lieferantName = lieferant.value?.name;

    detailPicklist.data = picklist;

    router.push({name: 'order_pick'}).catch(console.error);
  } catch (err: any) {
    await doAlert(err.message, 'Fehler');
  }
}

watch(() => store.data, async (data) => {
  if (data !== null) {
    lieferant.value = {value: String(data.Lieferant.LieferantNr), text: `${data.Lieferant.LieferantName} [${data.Lieferant.LieferantNr}]`, name: data.Lieferant.LieferantName};
    BestellNr.value = data.Nummer.toString();
    Lieferdatum.value = data.DatumParsed.format('YYYY-MM-DD');
    console.log(data);
  }

  await nextTick();
  form.value?.validate();
});

watch(lieferantSword, () => {
  if (debounceLieferantenTimeout.value) clearTimeout(debounceLieferantenTimeout.value);
  debounceLieferantenTimeout.value = setTimeout(loadLieferanten, 500);
});

watch(form, () => {
  form.value?.validate();
});

__expose({
  Error, Loading, DatePicker,
  lieferant,
  BestellNr,
  Lieferdatum,
  LieferscheinNr,
  formValid,
  lieferantenLoaded,
  lieferanten,
  debounceLieferantenTimeout,
  lieferantSword,
  lieferantenLoading,
  form,
  lieferantItems,
  bestellItems,
  order,
  save,
  ruleRequired,
  ruleNumber,
});


return (_ctx: any,_cache: any) => {
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_autocomplete = _resolveComponent("v-autocomplete")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item_subtitle = _resolveComponent("v-list-item-subtitle")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_unref(store).loading && !_unref(store).error)
      ? (_openBlock(), _createBlock(_component_v_container, { key: 0 }, {
          default: _withCtx(() => [
            _createVNode(_component_v_form, {
              modelValue: formValid.value,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formValid).value = $event)),
              ref: form.value
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_text_field, {
                  modelValue: LieferscheinNr.value,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((LieferscheinNr).value = $event)),
                  label: "Lieferscheinnummer",
                  rules: [ruleRequired],
                  maxlength: "10",
                  "aria-autocomplete": "none",
                  autocomplete: "off",
                  required: "",
                  autofocus: ""
                }, null, 8, ["modelValue", "rules"]),
                _createVNode(_component_v_autocomplete, {
                  modelValue: lieferant.value,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((lieferant).value = $event)),
                  disabled: Boolean(_unref(store).data),
                  items: lieferantItems.value,
                  "item-title": "text",
                  label: "Lieferant",
                  rules: [ruleRequired],
                  search: lieferantSword.value,
                  "onUpdate:search": _cache[2] || (_cache[2] = ($event: any) => ((lieferantSword).value = $event)),
                  loading: lieferantenLoading.value,
                  "return-object": true,
                  required: ""
                }, null, 8, ["modelValue", "disabled", "items", "rules", "search", "loading"]),
                (BestellNr.value)
                  ? (_openBlock(), _createBlock(_component_v_text_field, {
                      key: 0,
                      modelValue: BestellNr.value,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((BestellNr).value = $event)),
                      disabled: "",
                      items: bestellItems.value,
                      rules: [ruleNumber],
                      label: "Bestellnummer"
                    }, null, 8, ["modelValue", "items", "rules"]))
                  : _createCommentVNode("", true),
                _createVNode(DatePicker, {
                  class: "mt-5",
                  modelValue: Lieferdatum.value,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((Lieferdatum).value = $event)),
                  label: "Lieferdatum",
                  rules: [ruleRequired]
                }, null, 8, ["modelValue", "rules"]),
                _createVNode(_component_v_btn, {
                  color: "primary",
                  onClick: save,
                  disabled: !formValid.value
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Erstellen")
                  ], undefined, true),
                  _: 1
                }, 8, ["disabled"])
              ], undefined, true),
              _: 1
            }, 8, ["modelValue"]),
            (order.value)
              ? (_openBlock(), _createBlock(_component_v_card, {
                  key: 0,
                  class: "mt-10"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_card_title, { class: "py-3" }, {
                      default: _withCtx(() => [
                        _createTextVNode("Bestellung")
                      ], undefined, true),
                      _: 1
                    }),
                    _createVNode(_component_v_list, { class: "pt-0 pb-3" }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(order.value.BestellungPosition, (position) => {
                          return (_openBlock(), _createBlock(_component_v_list_item, {
                            key: position.PosNr
                          }, {
                            prepend: _withCtx(() => [
                              _createElementVNode("div", _hoisted_2, _toDisplayString(position.PosNr), 1)
                            ]),
                            default: _withCtx(() => [
                              _createVNode(_component_v_list_item_title, null, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(position.Artikel.ArtikelBezeichnung1) + " ", 1),
                                  _createElementVNode("small", _hoisted_3, "#" + _toDisplayString(position.Artikel.ArtikelNr), 1)
                                ], undefined, true),
                                _: 2
                              }, 1024),
                              _createVNode(_component_v_list_item_subtitle, null, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(position.Artikel.ArtikelBezeichnung2), 1)
                                ], undefined, true),
                                _: 2
                              }, 1024),
                              _createVNode(_component_v_list_item_subtitle),
                              _createVNode(_component_v_list_item_subtitle),
                              _createVNode(_component_v_list_item_subtitle, null, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(position.Einheit.Menge) + " " + _toDisplayString(position.Einheit.Einheit) + " ", 1),
                                  (position.Artikel.ArtikelNrLieferant)
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                        _createTextVNode("– " + _toDisplayString(position.Artikel.ArtikelNrLieferant), 1)
                                      ], 64))
                                    : _createCommentVNode("", true)
                                ], undefined, true),
                                _: 2
                              }, 1024)
                            ], undefined, true),
                            _: 2
                          }, 1024))
                        }), 128))
                      ], undefined, true),
                      _: 1
                    })
                  ], undefined, true),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ], undefined, true),
          _: 1
        }))
      : (_unref(store).error)
        ? (_openBlock(), _createBlock(Error, {
            key: 1,
            module: _unref(store).$id
          }, null, 8, ["module"]))
        : (_openBlock(), _createBlock(Loading, { key: 2 }))
  ]))
}
}

})